import { render, staticRenderFns } from "./RoleQermission.vue?vue&type=template&id=15693f5b&scoped=true&"
import script from "./RoleQermission.vue?vue&type=script&lang=js&"
export * from "./RoleQermission.vue?vue&type=script&lang=js&"
import style0 from "./RoleQermission.vue?vue&type=style&index=0&id=15693f5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15693f5b",
  null
  
)

export default component.exports